'use client'

import { useState } from 'react'
import { ChevronDownIcon } from '@heroicons/react/16/solid'
import { Field, Label, Switch } from '@headlessui/react'
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/react'
import { ChevronUpDownIcon } from '@heroicons/react/16/solid'

import Topbar from './Topbar';
import Footer from './Footer';

const services = [
  { id: 0, name: '' },
  { id: 1, name: 'Fractional Leadership' },
  { id: 2, name: 'Coaching and Mentoring' },
  { id: 3, name: 'Assessment and Feedback' },
  { id: 4, name: 'Architecture and Modeling' },
  { id: 5, name: 'Design and Development' },
  { id: 6, name: 'Custom Consulting' },
  { id: 7, name: 'Workshops' },
  { id: 8, name: 'Other' },
]

export default function ServiceRequest() {
  const [addToEmailList, setAddToEmailList] = useState(true)
  const [selected, setSelected] = useState(services[0])
  const [isSubmitting, setIsSubmitting] = useState(false);
  

  function handleSubmitServiceRequest(event) {
    event.preventDefault()
    const data = new FormData(event.target)
    const first_name = data.get('first-name')
    const last_name = data.get('last-name')
    const company = data.get('company')
    const phone_number = data.get('phone-number')
    const email = data.get('email')
    // placeholder for add_to_email_list
    const service = selected.name
    const ideal_start_date = data.get('ideal-start-date')
    const message = data.get('message')
  
    setIsSubmitting(true); // Disable the button and show the spinner
    
    fetch('https://binaryinventions.com/api/service_request', { 
      method: 'POST',
      headers: {        
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        first_name: first_name,
        last_name: last_name,
        company: company,
        phone_number: phone_number,
        email: email,
        add_to_email_list: addToEmailList,
        service_requested: service,
        potential_start_date: ideal_start_date,
        discussion_topics: message,
      }), 
    })
    .then((data) => {
      console.log('Success:', data)
      window.location.href = 'https://binaryinventions.com/inputcode/service_request'
    })
    .catch((error) => {
      console.error('Error:', error)
    }).finally(() => {
      setIsSubmitting(false); // Enable the button and hide the spinner
    })
  }

  return (
    <div>
    <Topbar />        
    <div className="isolate bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Services Request</h2>
        <p className="mt-2 text-lg/8 text-gray-600">Complete the information below and we'll be in touch.<br/> Still unsure then let's <a href="https://calendly.com/ryan-binaryinventions" target="_blank" rel="noreferrer" className="font-bold text-blue-500">talk first</a></p>
      </div>
      <form onSubmit={handleSubmitServiceRequest} method="POST" className="mx-auto mt-16 max-w-xl sm:mt-20">
        <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
          <div>
            <label htmlFor="first-name" className="block text-sm/6 font-semibold text-gray-900">
              First name
            </label>
            <div className="mt-2.5">
              <input
                id="first-name"
                name="first-name"
                type="text"
                autoComplete="given-name"
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
            </div>
          </div>
          <div>
            <label htmlFor="last-name" className="block text-sm/6 font-semibold text-gray-900">
              Last name
            </label>
            <div className="mt-2.5">
              <input
                id="last-name"
                name="last-name"
                type="text"
                autoComplete="family-name"
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="company" className="block text-sm/6 font-semibold text-gray-900">
              Company
            </label>
            <div className="mt-2.5">
              <input
                id="company"
                name="company"
                type="text"
                autoComplete="organization"
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="phone-number" className="block text-sm/6 font-semibold text-gray-900">
              Phone number
            </label>
            <div className="mt-2.5">
              <div className="flex rounded-md bg-white outline outline-1 -outline-offset-1 outline-gray-300 has-[input:focus-within]:outline has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-indigo-600">
                <div className="grid shrink-0 grid-cols-1 focus-within:relative">
                  <select
                    id="country"
                    name="country"
                    autoComplete="country"
                    aria-label="Country"
                    className="col-start-1 row-start-1 w-full appearance-none rounded-md py-2 pl-3.5 pr-7 text-base text-gray-500 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  >
                    <option>US</option>
                    <option>CA</option>
                    <option>EU</option>
                  </select>
                  <ChevronDownIcon
                    aria-hidden="true"
                    className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                  />
                </div>
                <input
                  id="phone-number"
                  name="phone-number"
                  type="text"
                  placeholder="123-456-7890"
                  className="block min-w-0 grow py-1.5 pl-1 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"
                />
              </div>
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="email" className="block text-sm/6 font-semibold text-gray-900">
              Email
            </label>
            <div className="mt-2.5">
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
            </div>
            <Field className="flex gap-x-4 sm:col-span-2">
            <div className="flex h-6 items-center">
              <Switch
                name="add-to-email-list"
                checked={addToEmailList}
                onChange={setAddToEmailList}
                className="group flex w-8 flex-none cursor-pointer rounded-full bg-gray-200 p-px ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 data-[checked]:bg-gray-600"
              >
                <span className="sr-only">Join our email list.</span>
                <span
                  aria-hidden="true"
                  className="size-4 transform rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition duration-200 ease-in-out group-data-[checked]:translate-x-3.5"
                />
              </Switch>
            </div>
            <Label className="text-sm/6 text-gray-600">
              Selected automatically joins our email list!
            </Label>
          </Field>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="project" className="block text-sm/6 font-semibold text-gray-900">
                Service Requested
            </label>
            <div className="mt-2.5">
                <Listbox value={selected} onChange={setSelected}>
                  <div className="relative mt-2">
                    <ListboxButton className="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                      <span className="col-start-1 row-start-1 truncate pr-6">{selected.name}</span>
                      <ChevronUpDownIcon
                        aria-hidden="true"
                        className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                      />
                    </ListboxButton>

                    <ListboxOptions
                      transition
                      className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                    >
                      {services.map((service) => (
                        <ListboxOption
                          key={service.id}
                          value={service}
                          className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white data-[focus]:outline-none"
                        >
                          <span className="block truncate font-normal group-data-[selected]:font-semibold">{service.name}</span>

                        </ListboxOption>
                      ))}
                    </ListboxOptions>
                  </div>
                </Listbox>
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="ideal-start-date" className="block text-sm/6 font-semibold text-gray-900">
              Ideal start date
            </label>
            <div className="mt-2.5">
              <input
                id="ideal-start-date"
                name="ideal-start-date"
                type="date"
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
              />
            </div>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="message" className="block text-sm/6 font-semibold text-gray-900">
              Let us know anything else that is important to you
            </label>
            <div className="mt-2.5">
              <textarea
                id="message"
                name="message"
                rows={4}
                className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                defaultValue={''}
              />
            </div>
          </div>
        </div>
        <div className="mt-10">
        <button
          type="submit"
          disabled={isSubmitting}
          className={`block w-full rounded-md px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm ${
            isSubmitting
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-gray-600 hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
          }`}
        >
          <div className="flex items-center justify-center gap-2">
            {isSubmitting && (
              <svg
                className="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                ></path>
              </svg>
            )}
            Submit Request
          </div>
        </button>
        </div>
      </form>
    </div>
    <Footer />
    </div>
  )
}